import React from 'react';

import {ActionButton, CancelButton, SubmitButton} from 'iss/widgets/Buttons';
import {FormWithState} from 'iss/widgets/Forms';
import {FormSection} from 'iss/widgets/form/FormSection';
import Modal from 'iss/widgets/bootstrap/Modal';

export function ModalForm({initialValues= {}, onCancel, onSubmit, proceedText, proceedLook = "primary", additionalButtons, children}) {
  return <FormWithState initialValues={initialValues} onSubmit={onSubmit}>
    <Modal.Contents>
      {{
        body: children,
        footer: <React.Fragment>
          <CancelButton onClick={onCancel} />
          {additionalButtons}
          <SubmitButton buttonLook={proceedLook}>{proceedText}</SubmitButton>
        </React.Fragment>
      }}
    </Modal.Contents>
  </FormWithState>;
}

export function ModalFormSection({valuePath, onCancel, onSubmit, proceedText, proceedLook = "primary", additionalButtons, children}) {
  return <FormSection valuePath={valuePath}>
    <Modal.Contents>
      {{
        body: children,
        footer: <React.Fragment>
          <CancelButton onClick={onCancel} />
          {additionalButtons}
          <ActionButton buttonLook={proceedLook} onClick={onSubmit}>{proceedText}</ActionButton>
        </React.Fragment>
      }}
    </Modal.Contents>
  </FormSection>;
}



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/batchOps/ModalForm.jsx